<template>
  <div class="dashboard">
    <div class="page-title">数据概览</div>

    <div class="empty-hint" v-if="isEmpty">
      当前版本暂无数据。请先在顶部切换到对应版本，再添加卡密、素材等内容。
    </div>

    <div class="stat-grid">
      <div class="stat-card">
        <div class="stat-value">{{ stats.totalCards }}</div>
        <div class="stat-label">总卡密数量</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ stats.activeCards }}</div>
        <div class="stat-label">已激活</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ stats.inactiveCards }}</div>
        <div class="stat-label">未激活</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ stats.shippedOrders }}</div>
        <div class="stat-label">已发货</div>
      </div>
    </div>

    <div class="section">
      <div class="section-title">最近激活</div>
      <table class="table">
        <thead>
          <tr><th>卡号</th><th>套餐</th><th>时间</th></tr>
        </thead>
        <tbody>
          <tr v-for="r in stats.recentActivations" :key="r.id">
            <td>{{ r.cardNo }}</td>
            <td>{{ r.pkg }}</td>
            <td>{{ r.time }}</td>
          </tr>
          <tr v-if="!stats.recentActivations || stats.recentActivations.length === 0">
            <td colspan="3" style="text-align:center;color:#999;">暂无数据</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { api } from '@/utils/api';
import { getAdminSite } from '@/utils/site';

export default {
  name: 'AdminDashboard',
  data() {
    return {
      stats: { totalCards: 0, activeCards: 0, inactiveCards: 0, shippedOrders: 0, recentActivations: [] }
    };
  },
  computed: {
    isEmpty() {
      return this.stats.totalCards === 0 && (!this.stats.recentActivations || this.stats.recentActivations.length === 0);
    }
  },
  async created() {
    await this.fetchStats();
  },
  methods: {
    async fetchStats() {
      const site = getAdminSite();
      const data = await api.get('/api/admin/dashboard?site=' + site);
      if (data.code === 200) this.stats = data.data;
    }
  }
};
</script>

<style scoped>
.dashboard {
  padding: 20px;
}
.page-title {
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 20px;
}
.empty-hint {
  background: #fff8e6;
  border: 1px solid #ffe0a3;
  color: #996600;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 16px;
}
.stat-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 14px;
  margin-bottom: 24px;
}
.stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 18px 16px;
  text-align: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
  border-top: 3px solid #27ae60;
}
.stat-value {
  font-size: 26px;
  font-weight: 700;
  color: #1a1a1a;
}
.stat-label {
  font-size: 13px;
  color: #999;
  margin-top: 4px;
}
.section {
  background: #fff;
  border-radius: 12px;
  padding: 18px 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.04);
}
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.table th {
  text-align: left;
  padding: 10px 8px;
  color: #999;
  font-weight: 500;
  border-bottom: 1px solid #eee;
}
.table td {
  padding: 10px 8px;
  color: #333;
  border-bottom: 1px solid #f5f5f5;
}
</style>
